import styled from '@emotion/styled';
import { useState } from 'react';
import { useMatchList } from './useMatchList';
import { MatchCard } from './MatchCard';
import { PageTitle } from 'ui/components/elements/PageTitle/PageTitle';
import { AboutService } from 'ui/components/company/features/AboutService';
import { UserTypeTab, TabType } from 'ui/components/agent/features/Tab/UserTypeTab';
import { mqUser } from 'utils/responsive';

const descriptions: { [key: string]: string[] } = {
    メッセージのやり取り: ['企業情報を登録すると、売り手企業へのオファーが可能となります。（所要時間約3分）'],
};

const Wrapper = styled.div`
    padding: 18px 50px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    text-align: left;
    background-color: #f8f9fd;
    height: auto;
    min-height: calc(100vh - var(--height-pc-header));

    ${mqUser('SP')} {
        padding: 18px 15px;
    }
`;

const MatchListContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 0;
    margin-top: 20px;
`;

export const MatchList: React.FC = () => {
    const { loading, matchList } = useMatchList();
    const [activeTab, setActiveTab] = useState<TabType>('all');

    const filteredMatchList = matchList.filter((match) => {
        switch (activeTab) {
            case 'seller':
                return !!match.company.id;
            case 'buyer':
                return !!match.buyer.id;
            case 'all':
            default:
                return true;
        }
    });

    return (
        <Wrapper>
            <PageTitle title="マッチング企業一覧" />
            <AboutService descriptions={descriptions} />
            <UserTypeTab activeTab={activeTab} onTabChange={setActiveTab} />
            <MatchListContainer>
                {!loading && filteredMatchList.map((match) => <MatchCard key={match.id} match={match} />)}
            </MatchListContainer>
        </Wrapper>
    );
};
